import { connect } from 'react-redux';
import CreateAccountComponent from '../../components/CreateAccount/Index';
import {
  getInvitationByCode,
  register,
  upload
} from "../../actions/CreateAccount"
import {
  logout
} from "../../actions/App";

const mapStateToProps = (state) => {
  const {
    ifRequestSuccess,
    department,
    get_invitation_by_code,
    error,
    successResponse,
    uploadSuccessResponse,
    uploadErrorMsg,
    invitation_error_message
  } = state.create_account;

  return {
    ifRequestSuccess,
    department,
    get_invitation_by_code,
    error,
    successResponse,
    uploadSuccessResponse,
    uploadErrorMsg,
    invitation_error_message,
  }
}

const mapDispathToProps = (dispatch) => {
  return {
    getInvitationByCode: (code) => {
      dispatch(getInvitationByCode(code));
    },
    register: (code, obj) => {
      dispatch(register(code, obj));
    },
    upload: (formData, code) => {
      dispatch(upload(formData, code));
    },
    logout: () => {
      window.localStorage.clear();
      dispatch(logout());
    }
  }
}

const CreateAccount = connect(
  mapStateToProps,
  mapDispathToProps
)(CreateAccountComponent);

export default CreateAccount;


// WEBPACK FOOTER //
// ./src/containers/CreateAccount/index.js